import React from 'react';
import { makeStyles } from '@bb-ui/react-library';
import { SnackbarProvider } from '@bb-ui/react-library/dist/components/Snackbar';
import { BrowserRouter } from 'react-router-dom';
import { default as AppConfigProvider } from 'contexts/AppConfigContext';
import { AuthProvider } from 'components/AuthProvider';
import { WaitForContexts } from 'components/WaitForContexts';
import { AuthContextProvider } from 'contexts/AuthContext';
import { ClientsContextProvider } from 'contexts/ClientContext';
import { Routes } from './routes';
import { Sidebar } from 'components/Sidebar';
import { styles } from './App.styles';
import { ExperienceProvider, useExperience } from 'contexts/ExperienceContext';
import { ExperienceBanner } from 'components/ExperienceBanner';

export const useStyles = makeStyles(styles);

export const App: React.FunctionComponent = () => (
  <ExperienceProvider>
    <AppInner />
  </ExperienceProvider>
);

const AppInner: React.FunctionComponent = () => {
  const { isModern, bannerVisible } = useExperience();
  const classes = useStyles();

  const rootClass = `${isModern ? classes.root : classes.rootClassic}${bannerVisible ? ` ${classes.rootWithBanner}` : ''}`;

  return (
    <>
      <ExperienceBanner />
      <div className={rootClass}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <AppConfigProvider>
            <AuthProvider>
              <AuthContextProvider>
                <ClientsContextProvider>
                  <WaitForContexts>
                    <SnackbarProvider key={undefined} variant={undefined} domRoot={document.body}>
                      {isModern && <Sidebar />}
                      <Routes />
                    </SnackbarProvider>
                  </WaitForContexts>
                </ClientsContextProvider>
              </AuthContextProvider>
            </AuthProvider>
          </AppConfigProvider>
        </BrowserRouter>
      </div>
    </>
  );
};
